import { Capacity } from './../../shared/models/capacity.model';
import { Action } from '@ngrx/store';
import { IOverrideCapacity } from '@signal/asp-data-commons/lib/interfaces/availability';

export enum CapacityActionTypes {
    LOAD_CAPACITY = '[Capacity] Load capacity',
    LOAD_CAPACITY_SUCCESS = '[Capacity] Load capacity success',
    LOAD_CAPACITY_FAILURE = '[Capacity] Load capacity failure',
    LOAD_CAPACITY_FOR_DATE = '[Capacity] Load capacity for date',
    LOAD_CAPACITY_FOR_DATE_SUCCESS = '[Capacity] Load capacity for date success',
    LOAD_CAPACITY_FOR_DATE_FAILURE = '[Capacity] Load capacity for date failure',
    UPDATE_CAPACITY = '[Capacity] Update capacity',
    UPDATE_CAPACITY_SUCCESS = '[Capacity] Update capacity success',
    UPDATE_CAPACITY_FAILURE = '[Capacity] Update capacity failure',
    LOAD_CAPACITY_OVERRIDE_FOR_DATE = '[Capacity] Load capacity override for date',
    LOAD_CAPACITY_OVERRIDE_FOR_DATE_SUCCESS = '[Capacity] Load capacity override for date success',
    LOAD_CAPACITY_OVERRIDE_FOR_DATE_FAILURE = '[Capacity] Load capacity override for date failure',
    UPDATE_CAPACITY_OVERRIDE = '[Capacity] Update capacity override',
    UPDATE_CAPACITY_OVERRIDE_SUCCESS = '[Capacity] Update capacity override success',
    UPDATE_CAPACITY_OVERRIDE_FAILURE = '[Capacity] Update capacity override failure'
}


export class LoadCapacity implements Action {
    readonly type: string = CapacityActionTypes.LOAD_CAPACITY;

    constructor() {
    }
}

export class LoadCapacitySuccess implements Action {
    readonly type = CapacityActionTypes.LOAD_CAPACITY_SUCCESS;

    constructor(public payload: { capacity: Capacity[] }) {
    }
}

export class LoadCapacityFailure implements Action {
    readonly type = CapacityActionTypes.LOAD_CAPACITY_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadCapacityForDate implements Action {
    readonly type: string = CapacityActionTypes.LOAD_CAPACITY_FOR_DATE;

    constructor(public payload: string) {
    }
}

export class LoadCapacityForDateSuccess implements Action {
    readonly type = CapacityActionTypes.LOAD_CAPACITY_FOR_DATE_SUCCESS;

    constructor(public payload: string) {
    }
}

export class LoadCapacityForDateFailure implements Action {
    readonly type = CapacityActionTypes.LOAD_CAPACITY_FOR_DATE_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateCapacity implements Action {
    readonly type = CapacityActionTypes.UPDATE_CAPACITY;
    constructor(public payload: Capacity) {
    }
}

export class UpdateCapacitySuccess implements Action {
    readonly type = CapacityActionTypes.UPDATE_CAPACITY_SUCCESS;
    constructor(public payload: Capacity) {
    }
}

export class UpdateCapacityFailure implements Action {
    readonly type = CapacityActionTypes.UPDATE_CAPACITY_FAILURE;
    constructor(public payload: { error: string }) {
    }
}

export class LoadCapacityOverrideForDate implements Action {
    readonly type: string = CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE;

    constructor(public payload: string) {
    }
}

export class LoadCapacityOverrideForDateSuccess implements Action {
    readonly type = CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE_SUCCESS;

    constructor(public payload: IOverrideCapacity) {
    }
}

export class LoadCapacityOverrideForDateFailure implements Action {
    readonly type = CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateCapacityOverride implements Action {
    readonly type = CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE;
    constructor(public payload: IOverrideCapacity) {
    }
}

export class UpdateCapacityOverrideSuccess implements Action {
    readonly type = CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE_SUCCESS;
    constructor(public payload: IOverrideCapacity) {
    }
}

export class UpdateCapacityOverrideFailure implements Action {
    readonly type = CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE_FAILURE;
    constructor(public payload: { error: string }) {
    }
}

export type CapacityActions =
    LoadCapacity
    | LoadCapacitySuccess
    | LoadCapacityFailure
    | LoadCapacityForDate
    | LoadCapacityForDateSuccess
    | LoadCapacityForDateFailure
    | UpdateCapacity
    | UpdateCapacitySuccess
    | UpdateCapacityFailure
    | LoadCapacityOverrideForDate
    | LoadCapacityOverrideForDateSuccess
    | LoadCapacityOverrideForDateFailure
    | UpdateCapacityOverride
    | UpdateCapacityOverrideSuccess
    | UpdateCapacityOverrideFailure;
